/* eslint-disable import/order */
import { planSummaryEntryPoint } from '@jira/spa-apps__advanced-roadmaps-plan-summary/src/planSummaryEntryPoint.entrypoint.tsx';
import { advancedRoadmapsPlanPageInitialChecksResource } from '@jira/router-resources__advanced-roadmaps-plan/src/advancedRoadmapsPlanPageInitialChecksResource.tsx';
import { advancedRoadmapsSummaryDataResource } from '@jira/router-resources__advanced-roadmaps-summary/src/advancedRoadmapsSummaryDataResource.tsx';
import { summaryPagePreferencesResource } from '@jira/router-resources__advanced-roadmaps-summary/src/summaryPagePreferencesResource.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { createLayout } from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';
import { getNavigationSidebarPlanResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { jiraSpaResources } from '@jira/router-resources__spa-page-container/src/jiraSpaResources.tsx';
import { arjSummaryEmbedRoute } from '@jira/router-routes__advanced-roadmaps-embed-routes/src/arjSummaryEmbedRoute.tsx';
import { createChromelessEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { PlanSummaryEmbedPage, LazyPlanSummaryEmbed } from './ui/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

const planSummaryEmbedRouteEntry = createChromelessEntryPoint({
	main: planSummaryEntryPoint,
});
export const arjSummaryEmbedRouteEntry: Route = createEntry(arjSummaryEmbedRoute, () => ({
	group: 'software',
	// eslint-disable-next-line no-restricted-syntax
	component: PlanSummaryEmbedPage,
	entryPoint: () => planSummaryEmbedRouteEntry,
	layout: createLayout({
		isChromeless: true,
	}),
	resources: [
		...getNavigationSidebarPlanResources(),
		advancedRoadmapsPlanPageInitialChecksResource,
		advancedRoadmapsSummaryDataResource,
		summaryPagePreferencesResource,
		...jiraSpaResources(),
	],
	preloadOptions: {
		earlyChunks: ['advanced-roadmaps-early-entry'],
	},
	forPaint: [LazyPlanSummaryEmbed],
	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
